<template>
  <div style="width: 560px;">
    <a-alert :show-icon="true" type="warning">
      <div slot="message">
        <div>* 图片上传 JPG 或 PNG 格式，建议尺寸 1080px * 540px</div>
        <div>* 多个横幅图片建议尺寸大小保持一致，最多允许上传5张</div>
      </div>
    </a-alert>
    <a-tabs :animated="false" :tab-bar-gutter="69" style="margin-top: 15px;">
      <a-tab-pane :key="1" tab="横幅图片">
        <a-spin :spinning="searching">
          <div :key="item.id" class="image-box" v-for="(item, index) in result.data">
            <a-input @blur="updateImage(item, false)" @change="updateImage(item, true)"
                     class="link-input" placeholder="请输入以 http:// 或 https:// 开头的链接，非必填" v-model="item.config.link"/>
            <ResourceImg :id="item.config.rs_id" height="180" resize="m_8,w_360,h_180" width="360"/>
            <div style="padding: 21px 60px;">
              <a-space :size="21" direction="vertical">
                <a-button :disabled="index===0" @click="moveUp(index)"
                          icon="arrow-up" shape="round">上移
                </a-button>
                <a-button :disabled="index===(result.total-1)" @click="moveDown(index)"
                          icon="arrow-down" shape="round">下移
                </a-button>
                <a-popconfirm @confirm="remove(index)" title="您确认要删除吗？">
                  <a-button icon="delete" shape="round" type="danger">删除</a-button>
                </a-popconfirm>
              </a-space>
            </div>
          </div>
          <ImageUpload :height="90" :width="560" @input="createImage" title="点击上传横幅图片" v-show="result.total < 5"/>
        </a-spin>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="上传视频">
        <Developing/>
      </a-tab-pane>
      <a-tab-pane :key="3" tab="三方视频">
        <Developing/>
      </a-tab-pane>
      <a-tab-pane :key="4" tab="视频直播">
        <Developing/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import api from "../../../../utils/api";
import func from "../../../../utils/func";
import Developing from "../../../../comps/Developing";
import ImageUpload from "../../../../comps/ImageUpload";
import ResourceImg from "../../../../comps/ResourceImg";

export default {
  name: "Banner",
  props: {album: Object},
  components: {ResourceImg, ImageUpload, Developing},
  data() {
    return {
      result: {
        total: 0,
        data: []
      },
      timeId: null,
      searching: false,
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    createImage(resource) {
      let config = {type: 1, rs_id: resource, sort_idx: this.result.total};
      return api.v1.album.banner.create(this.album.id, config).then(this.refresh);
    },
    updateImage(item, delay) {
      let saveFunc = () => {
        let isEmpty = item.config.link === "";
        let isHttp = item.config.link.indexOf("http://") === 0;
        let isHttps = item.config.link.indexOf("https://") === 0;
        if (isEmpty || isHttp || isHttps) {
          api.v1.album.banner.update(this.album.id, item.id, item.config);
        } else {
          this.$message.error("链接格式不正确！");
        }
      };
      clearTimeout(this.timeId);
      this.timeId = setTimeout(saveFunc, delay ? 3000 : 0);
    },
    moveUp(index) {
      let item1 = this.result.data[index];
      let item2 = this.result.data[index - 1];
      item1.config.sort_idx -= 1;
      item2.config.sort_idx += 1;
      api.v1.album.banner.update(this.album.id, item1.id, item1.config);
      api.v1.album.banner.update(this.album.id, item2.id, item2.config);
      func.arraySwap(this.result.data, index, index - 1);
    },
    moveDown(index) {
      let item1 = this.result.data[index];
      let item2 = this.result.data[index + 1];
      item1.config.sort_idx += 1;
      item2.config.sort_idx -= 1;
      api.v1.album.banner.update(this.album.id, item1.id, item1.config);
      api.v1.album.banner.update(this.album.id, item2.id, item2.config);
      func.arraySwap(this.result.data, index, index + 1);
    },
    remove(index) {
      const self = this;
      api.v1.album.banner
          .delete(this.album.id, this.result.data[index].id)
          .then(() => {
            for (let i = index + 1; i < self.result.total; i++) {
              let item = self.result.data[i];
              item.config.sort_idx -= 1;
              api.v1.album.banner.update(self.album.id, item.id, item.config);
            }
            this.refresh();
          });
    },
    refresh() {
      this.searching = true;
      api.v1.album.banner.search(this.album.id)
          .then(res => this.result = res)
          .finally(() => this.searching = false);
    }
  }
}
</script>

<style lang="less" scoped>
.image-box {
  display: flex;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px #e8e8e8 solid;
  position: relative;

  .link-input {
    left: 15px;
    bottom: 15px;
    width: 330px;
    position: absolute;
  }
}
</style>
